import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "勾",
  "use": "勾-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"勾\"><path stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke-width=\"1.333\" stroke=\"currentColor\" fill=\"currentColor\" d=\"M1.333 8 3 6.333l3.333 3.334L13 3l1.667 1.667L6.333 13l-5-5Z\" clip-rule=\"evenodd\" fill-rule=\"evenodd\" data-follow-fill=\"currentColor\" data-follow-stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol